<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="~@/common/imgs/banner3.png" alt="">
    </div>

    <!-- content -->
    <div class="news-content">
      <div class="news-left">
        <dl>
          <dt>
            <h3>集团介绍</h3>
            <p>Group Introduction</p>
          </dt>
          <dd class="w25">
            <router-link to="Intro"><span>企业简介</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="Architecture"><span>企业架构</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="Culture" class="active"><span>企业文化</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="DevelopmentCourse"><span>发展历程</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="Responsibility"><span>社会责任</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
        </dl>
      </div>

      <div class="news-right">
        <div class="news-bread">
          <h2>集团介绍</h2>/<i>企业文化</i>
        </div>
        <div class="culture-content">
          <h2>企业文化</h2>
          <h3>愿景</h3>
          <p>弘扬华剑乐业精神，铸就华剑百年品牌</p>
          <h3>宣言</h3>
          <p>勤奋，团结，务实，奉献</p>
          <h3>使命</h3>
          <p>精雕细琢，再创空间</p>
          <h3>宗旨</h3>
          <p>诚信，优质，高效，创新</p>
          <h3>管理理念</h3>
          <p>规范化，制度化，流程化，科学化</p>
          <h3>核心价值观</h3>
          <p>恪守诚信、以人为本、团结协作、自主创新、追求品质、和谐发展</p>
        </div>
      </div>
    </div>

    <!-- footer -->
    <foot-link></foot-link>

    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  export default {
    name: 'Culture',
    data() {
      return {}
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    }
  }
</script>

<style scoped>
  .culture-content {
    width: 100%;
  }

  .culture-content h2 {
    font-size: 26px;
    font-weight: bold;
    line-height: 48px;
  }

  .culture-content h3 {
    font-size: 22px;
    font-weight: bold;
    line-height: 40px;
    color: #023a91;
  }

  .culture-content p {
    font-size: 20px;
    margin-bottom: 12px;
  }

  @media screen and (max-width: 1120px) {
    #footer {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Culture.vue